import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initBrowserSentry } from './instrument';
import { ThemeProvider } from './lib/theme';
import './index.css';

// Before the first render, so an error thrown while mounting is still reported.
initBrowserSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
